<div class="eod-toggel__container" [class.toggle-sm]="toggleInput?.size === 'sm'">
    @if(toggleInput?.labelPosition === 'left'){<p class="toggel-label__left">{{ toggleInput?.label }}</p>}
    <div class="toggel-switch">
        <input
            class="toggel-switch__input"
            type="checkbox"
            [id]="toggleInput?.id"
            switch="bool"
            [checked]="toggleInput?.isActive"
            [disabled]="toggleInput?.disabled"
            (change)="onToggle($event)"
            [attr.aria-checked]="toggleInput?.isActive ? 'true' : 'false'"
            role="switch"
        />
        @if(toggleInput?.isLabel){<label class="toggel-label" [attr.for]="toggleInput?.id"></label>}
    </div>
    @if(toggleInput?.labelPosition === 'right'){<p class="toggel-label__right">{{ toggleInput?.label }}</p>}
</div>
